import { useState } from "react";
import { Popup as AntdPopup } from "antd-mobile";

const usePopup = () => {
	const [visiblePopup, setVisiblePopup] = useState(false);

	const showPopup = () => {
		setVisiblePopup(true);
	};

	const closePopup = () => {
		setVisiblePopup(false);
	};

	return {
		visiblePopup,
		showPopup,
		closePopup,
		PopupComp: AntdPopup,
	};
};

export default usePopup;
